import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Pin02 = function Pin02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m8.3767 15.6163-5.6568 5.6569m8.9745-14.6314-1.5609 1.5609c-.1273.1273-.191.191-.2635.2416a1 1 0 0 1-.207.1107c-.0822.0323-.1705.05-.347.0853l-3.6646.7329c-.9522.1904-1.4284.2856-1.6512.5367a1 1 0 0 0-.2425.801c.0461.3325.3895.6758 1.0762 1.3626l7.0857 7.0857c.6867.6867 1.0301 1.0301 1.3625 1.0762a1 1 0 0 0 .8011-.2426c.251-.2227.3462-.6989.5367-1.6512l.7329-3.6645c.0353-.1765.053-.2648.0853-.3471a1 1 0 0 1 .1107-.2069c.0506-.0726.1142-.1362.2416-.2635l1.5608-1.5609c.0814-.0814.1222-.1221.1669-.1577a1 1 0 0 1 .1259-.0852c.0496-.0284.1025-.051.2083-.0964l2.4944-1.069c.7277-.3119 1.0916-.4678 1.2568-.7198a1 1 0 0 0 .1439-.7471c-.0599-.2954-.3398-.5753-.8996-1.1351l-5.1431-5.1431c-.5599-.5599-.8398-.8398-1.1351-.8997a1 1 0 0 0-.7471.144c-.252.1652-.408.529-.7198 1.2568l-1.069 2.4943c-.0454.1058-.0681.1587-.0964.2084a1 1 0 0 1-.0853.1259c-.0355.0447-.0762.0854-.1576.1668"
    })
  }));
};
export default Pin02;